import React from 'react';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { faLayerGroup, faList } from '@fortawesome/free-solid-svg-icons';

import { LayersBarSection } from './LayersBarSection';
import { openPoiListingMenu } from 'handimap-react-lib/store/actions/poiListingActions';
import { useResponsive } from 'handimap-react-lib/hooks/useResponsive';
import { FontAwesomeSvgIcon } from 'handimap-react-lib/components/FontAwesomeSvgIcon';
import { setOpenDrawer } from 'handimap-react-lib/store/actions/sideBarActions';
import { LegendContainer } from './LegendContainer';

export const BottomBarSection = ({allResults, status}) => {

  const {t} = useTranslation();
  const dispatch = useDispatch();
  const { isMobile } = useResponsive();

  const { show } =  useSelector(state => state.legendList);

  const openPoiMenu = () => {
    dispatch(openPoiListingMenu());
  };

  const openLayerMenuMobile = () => {
    dispatch(setOpenDrawer(true));
  };

  const renderLayerSection = () => {
    if (isMobile) {
      return (
        <Button 
          id='layer_settings_open'
          sx={styles.button}
          aria-label={t('layer.aria-open')} 
          variant='contained'
          startIcon={<FontAwesomeSvgIcon icon={faLayerGroup}  />}
          onClick={openLayerMenuMobile}
        >
          {t('layer.layer-label')}
        </Button>
      );
    } else {
      return (
        <LayersBarSection />
      );
    }
  };

  const styles = {
    container : {
      display: 'flex',
      position: 'absolute',
      left: isMobile ? '2%' : 410, 
      right: isMobile ? '2%' : '1%',
      bottom: isMobile ? 50 : 30,
      zIndex: 20,
      pointerEvents: 'none'
    },
    layerContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-end',
      pointerEvents: 'auto'
    },
    button: {
      color: '#000000',
      backgroundColor: '#FFFFFF',
      textTransform: 'none',
      height: isMobile ? 50 : 60,
      fontSize: '1em',
      fontWeight: 700,
      '&:hover': {
        backgroundColor: 'primary.main'
      },
    }
  };

  return (
    <Stack sx={styles.container} spacing={1}>
      {show && !isMobile && (
        <LegendContainer allResults={allResults} status={status} />
      )}
      <Box sx={styles.layerContainer}>
        {renderLayerSection()}
        <Box>
          <Button 
            id='poi_listing_open'
            sx={styles.button} 
            aria-label={t('poiListing.open')}
            variant='contained'
            startIcon={<FontAwesomeSvgIcon icon={faList}  />}
            onClick={openPoiMenu}
          >
            {t('common.button_poi')}
          </Button>
        </Box>
      </Box>
    </Stack>
  );
};